import { App } from '@flipdish/api-client-typescript';

import { staffMemberViewConfiguration } from './staffMemberViewConfiguration';
import { type PortalUser, type ViewConfiguration } from './types';

export function getViewConfiguration(portalUser: PortalUser): ViewConfiguration | undefined {
  if (portalUser.permissions.includes('FlipdishStaff')) {
    return undefined;
  }

  if (portalUser.role === App.AppAccessLevelEnum.StaffMember) {
    return staffMemberViewConfiguration;
  }

  return undefined;
}
